import React from "react";

const Skills = () => {
  return (
    <div
      id="skills"
      className="bg-gray-50 lg:pt-16 lg:pb-24 lg:px-36 
     py-10 px-8 "
    >
      <h2 className="text-center lg:text-5xl text-4xl lg:mb-16 mb-10 font-[500]">
        Skills
      </h2>

      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-14 md:gap-8 gap-10">
        <div>
          <div className="h-16  bg-blue-50 border w-full flex items-center justify-center">
            <h3 className="text-xl font-[500]">Front-End</h3>
          </div>
          <div className="child:pl-2 child:py-2 child:border-b child:border-x ">
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/html.svg"
                className="h-12 w-14"
                alt="html"
              />
              <p className="uppercase">html5</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/css.svg"
                className="h-12 w-14"
                alt="css"
              />
              <p className="uppercase">css3</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/bootstrap.svg"
                className="h-12 w-14"
                alt="bootstrap"
              />
              <p className="uppercase">bootstrap 5</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/tailwind.svg"
                className="h-12 w-14"
                alt="tailwind"
              />
              <p className="uppercase">tailwind css</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/javascript.svg"
                className="h-12 w-14"
                alt="javascript"
              />
              <p className="uppercase">javascript</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/react.svg"
                className="h-12 w-14"
                alt="react"
              />
              <p className="uppercase">react js</p>
            </div>
          </div>
        </div>
        <div>
          <div className="h-16  bg-blue-50 border w-full flex items-center justify-center">
            <h3 className="text-xl font-[500]">Back-End</h3>
          </div>
          <div className="child:pl-2 child:py-2 child:border-b child:border-x ">
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/node.svg"
                className="h-12 w-14"
                alt="node"
              />
              <p className="uppercase">node js</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/expressjs.svg"
                className="h-12 w-14"
                alt="expressjs"
              />
              <p className="uppercase">express js</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/mongodb.svg"
                className="h-12 w-14"
                alt="mongodb"
              />
              <p className="uppercase">mongo db</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/api.svg"
                className="h-12 w-14"
                alt="api"
              />
              <p className="uppercase">rest api</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/stripe.svg"
                className="h-12 w-14"
                alt="stripe"
              />
              <p className="uppercase">stripe payment</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/jwt.svg"
                className="h-12 w-14"
                alt="jwt"
              />
              <p className="uppercase">json web token</p>
            </div>
          </div>
        </div>
        <div>
          <div className="h-16  bg-blue-50 border w-full flex items-center justify-center">
            <h3 className="text-xl font-[500]">Platform</h3>
          </div>

          <div className="child:pl-2 child:py-2 child:border-b child:border-x ">
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/git.svg"
                className="h-12 w-14"
                alt="git"
              />
              <p className="uppercase">git</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/github.svg"
                className="h-12 w-14"
                alt="github"
              />
              <p className="uppercase">github</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/firebase.svg"
                className="h-12 w-14"
                alt="firebase"
              />
              <p className="uppercase">firebase</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/netlify.svg"
                className="h-12 w-14"
                alt="netlify"
              />
              <p className="uppercase">netlify</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/heroku.svg"
                className="h-12 w-14"
                alt="heroku"
              />
              <p className="uppercase">heroku</p>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/Images/icons/figma.svg"
                className="h-12 w-14"
                alt="figma"
              />
              <p className="uppercase">figma</p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 lg:gap-14 md:gap-10">
        <div>
          <div>
            <p className="flex justify-between font-[500]">
              <span>HTML5 / CSS</span>
              <span>95%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="95"
                max="100"
              ></progress>
            </p>
            <p className="flex justify-between font-[500]">
              <span>Bootstrap / Tailwind CSS</span>
              <span>95%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="95"
                max="100"
              ></progress>
            </p>
            <p className="flex justify-between font-[500]">
              <span>JavaScript</span>
              <span>75%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="75"
                max="100"
              ></progress>
            </p>
            <p className="flex justify-between font-[500]">
              <span>React JS</span>
              <span>80%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="80"
                max="100"
              ></progress>
            </p>
          </div>
        </div>
        <div>
          <div>
            <p className="flex justify-between font-[500]">
              <span>Git / GitHub</span>
              <span>80%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="85"
                max="100"
              ></progress>
            </p>
            <p className="flex justify-between font-[500]">
              <span>MongoDB</span>
              <span>75%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="75"
                max="100"
              ></progress>
            </p>
            <p className="flex justify-between font-[500]">
              <span>Express.js</span>
              <span>70%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="70"
                max="100"
              ></progress>
            </p>
            <p className="flex justify-between font-[500]">
              <span>Node.js</span>
              <span>70%</span>
            </p>
            <p className="lg:mb-6 md:mb-6 mb-4">
              <progress
                className="progress rounded-none progress-success w-full"
                value="70"
                max="100"
              ></progress>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Skills;
